import React from "react";
import {Button, Card, CardBody, Col, Container, Row} from "reactstrap";
import offlineImg from '../../../assets/images/offline.avif'

const OfflinePage = () => {
    document.title = `Hors connexion | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
    return (
        <React.Fragment>
                <div className="min-vh-100 d-flex align-items-center">
                    <Container>
                        <Row className="justify-content-center">
                            <Col xl={5}>
                                <Card className="card-animate">
                                    <CardBody className="p-4">
                                        <div className="text-center">
                                            <img src={offlineImg} alt="" height="210" />
                                            <h3 className="mt-4 fw-semibold">Hors connexion</h3>
                                            <p className="text-muted mb-4 fs-14">Problème de reseau détécté, merci de vérifier ta connexion et de revenir à la page précédente ou</p>
                                            <Button color="success" className="btn-border"
                                                onClick={() => window.location.reload()}
                                            ><i className="ri-refresh-line align-bottom"></i> Actualiser la page</Button>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
        </React.Fragment>
    );
};

export default OfflinePage;